var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer_section"},[_c('div',{staticClass:"internet-content-provider"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.beian.num)+" ")]),_vm._v(" "+_vm._s(_vm.beian.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }